import React, { useEffect, useState } from 'react'
import { AssetInterface } from '../../../../../models/AssetModel/Asset';
import { useLanguageStore } from '../../../../../store/useLanguageStore';
import { darkModeBackgroudInputs } from '../../../../../utils/constants';
import { useDarkModeStore } from '../../../../../store/useDarkModeStore';
import ToastMessage from '../../../../../common/ToastMessage';
import useUpdateAsset from '../../../../../store/ReactQueries/assets/asset/useUpdateAsset';
import useAssetStatuses from '../../../../../store/ReactQueries/assets/assetStatuses/useAssetStatuses';

interface SelectStatusProps {
    statusId: string;
    asset: AssetInterface | undefined;
    page: number;
    pageSize: number;
}

export const SelectStatus: React.FC<SelectStatusProps> = ({ asset, statusId, page, pageSize }) => {

    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const { data: statuses } = useAssetStatuses(0, 0);

    const [selectedItem, setSelectedItem] = useState<string>(statusId);
    const [badgeColor, setBadgeColor] = useState<string>('#8D97A0');
    const updateAsset = useUpdateAsset(page, pageSize);

    useEffect(() => {
        const result = statuses.find(item => item.id === statusId);
        if (result && result.badgeColor) setBadgeColor(result.badgeColor);
    }, [statusId]);

    const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;
        if (asset) {
            const { id, barcode, assetCategoryId, title, assetTypeId, description, locationId, assetDepartmentId, assetStatusId, price, companyId } = asset;
            setSelectedItem(value);
            const upForm: AssetInterface = {
                id,
                barcode,
                assetCategoryId,
                title,
                assetTypeId,
                description,
                locationId,
                assetDepartmentId,
                assetStatusId: value,
                price,
                companyId
            }

            updateAsset.mutate(upForm, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => {
                    setSelectedItem(assetStatusId);
                    ToastMessage.Failed(error.message);
                }
            });
        }
    };

    return (
        <div className='d-flex flex-row align-items-center gap-1' title={language['AssetStatuses']}>
            <div style={{ width: 10, height: 10, background: badgeColor ? badgeColor : '#A0D76A' }} />
            <select
                className='select-asset'
                style={{ color: darkMode ? 'white' : 'initial', background: darkMode ? darkModeBackgroudInputs : 'initial' }}
                value={selectedItem}
                onChange={(e) => {
                    e.preventDefault();
                    handleSelect(e);
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {
                    statuses?.map(({ id, title }) =>
                        <option key={id} value={id}>{title}</option>
                    )
                }
            </select>
        </div>
    );
}
export default SelectStatus